import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { SelectionManagerProvider } from 'utils/selection-manager/SelectionManager'
import { ProductsSearch } from 'domains/products/components/search/ProductsSearch'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,

    id: string
  */
  }> {}

export const ProductsSearchPage: FunctionComponent<Props> = ({ match }) => {
  const messages = useDomainMessages({
    title: 'productsDomain.search.title',
  })

  return (
    <Fragment>
      <DocumentTitle titleId={null} title={messages.title} />
      <SelectionManagerProvider>
        <ProductsSearch />
      </SelectionManagerProvider>
    </Fragment>
  )
}
